function updateLabelText() {
  const emailInput = document.getElementById('email')
  const countrySelect = document.getElementById('country')
  const requiredNote = document.querySelector('.required-note')

  const emailLabel = document.querySelector('label[for="email"]')
  if (emailInput.value) {
    emailLabel.textContent = 'EMAIL'
  } else {
    emailLabel.textContent = '* EMAIL'
  }

  const countryLabel = document.querySelector('label[for="country"]')
  if (countrySelect.value) {
    countryLabel.textContent = 'COUNTRY'
  } else {
    countryLabel.textContent = '* CHOOSE COUNTRY'
  }

  if (emailInput.value && countrySelect.value) {
    if (requiredNote) {
      requiredNote.style.display = 'none'
    }
  } else {
    if (requiredNote) {
      requiredNote.style.display = 'block'
    }
  }
}

document.getElementById('email').addEventListener('input', updateLabelText)
document.getElementById('country').addEventListener('change', updateLabelText)
